"use strict";
/*
 * Created on 27. 2. 2019
 *
 * Copyright (c) 2018 Etnetera, a.s. All rights reserved.
 * Intended for internal use only.
 * http://www.etnetera.cz
 */

var _construct = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/construct");

var _regeneratorRuntime = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _get = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/get");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var immutable_1 = require("immutable");

var BufferingConsumer_1 = require("./BufferingConsumer");
/**
 * Abstraction of consumer (sink) with back pressure implemented by promise.
 * @author Stepan Mik
 */


var ParallelBufferingConsumer =
/*#__PURE__*/
function (_BufferingConsumer_1$) {
  _inherits(ParallelBufferingConsumer, _BufferingConsumer_1$);

  function ParallelBufferingConsumer() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, ParallelBufferingConsumer);

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(ParallelBufferingConsumer)).call.apply(_getPrototypeOf2, [this].concat([arguments.length <= 0 ? undefined : arguments[0], arguments.length <= 2 ? undefined : arguments[2]])));
    _this.parallelism = arguments.length <= 1 ? undefined : arguments[1];
    return _this;
  }

  _createClass(ParallelBufferingConsumer, [{
    key: "init",
    value: function () {
      var _init = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _get(_getPrototypeOf(ParallelBufferingConsumer.prototype), "init", this).call(this);

              case 2:
                this.tasks = immutable_1.List();

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      return function init() {
        return _init.apply(this, arguments);
      };
    }()
  }, {
    key: "finalize",
    value: function () {
      var _finalize = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!this.err) {
                  _context2.next = 2;
                  break;
                }

                throw this.err;

              case 2:
                _context2.next = 4;
                return _get(_getPrototypeOf(ParallelBufferingConsumer.prototype), "finalize", this).call(this);

              case 4:
                _context2.next = 6;
                return Promise.all(this.tasks);

              case 6:
                return _context2.abrupt("return", this.acc);

              case 7:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      return function finalize() {
        return _finalize.apply(this, arguments);
      };
    }()
  }, {
    key: "invokeProcess",
    value: function invokeProcess(buffer) {
      var _this2 = this;

      if (this.err) {
        return Promise.reject(this.err);
      }

      var task = this.process(buffer).then(function (res) {
        _this2.acc = _this2.reduce(_this2.acc, res);
      });
      this.tasks = this.tasks.push(task);
      task.then(function () {
        _this2.tasks = _this2.tasks.remove(_this2.tasks.indexOf(task));
      }, function (err) {
        _this2.tasks = _this2.tasks.remove(_this2.tasks.indexOf(task));
        _this2.err = err;
      });

      if (this.tasks.size < this.parallelism) {
        return Promise.resolve();
      }

      return Promise.race(this.tasks);
    }
  }]);

  return ParallelBufferingConsumer;
}(BufferingConsumer_1.BufferingConsumer);

exports.ParallelBufferingConsumer = ParallelBufferingConsumer; // tslint:disable-next-line:no-namespace

var ParallelBufferingConsumers;

(function (ParallelBufferingConsumers) {
  function fromFunction(size, parallelism, processor) {
    // tslint:disable-next-line:max-classes-per-file
    return new (
    /*#__PURE__*/
    function (_ParallelBufferingCon) {
      _inherits(_class, _ParallelBufferingCon);

      function _class() {
        _classCallCheck(this, _class);

        return _possibleConstructorReturn(this, _getPrototypeOf(_class).apply(this, arguments));
      }

      _createClass(_class, [{
        key: "process",
        value: function process(buffer) {
          return processor(buffer);
        }
      }, {
        key: "reduce",
        value: function reduce(acc, res) {
          /**/
        }
      }]);

      return _class;
    }(ParallelBufferingConsumer))(size, parallelism);
  }

  ParallelBufferingConsumers.fromFunction = fromFunction;

  function fromFunctionAndReducer(size, parallelism, initial, processor, reducer) {
    // tslint:disable-next-line:max-classes-per-file
    return _construct(
    /*#__PURE__*/
    function (_ParallelBufferingCon2) {
      _inherits(_class2, _ParallelBufferingCon2);

      function _class2() {
        _classCallCheck(this, _class2);

        return _possibleConstructorReturn(this, _getPrototypeOf(_class2).apply(this, arguments));
      }

      _createClass(_class2, [{
        key: "process",
        value: function process(buffer) {
          return processor(buffer);
        }
      }, {
        key: "reduce",
        value: function reduce(acc, res) {
          return reducer(acc, res);
        }
      }]);

      return _class2;
    }(ParallelBufferingConsumer), [size, parallelism, initial]);
  }

  ParallelBufferingConsumers.fromFunctionAndReducer = fromFunctionAndReducer;
})(ParallelBufferingConsumers = exports.ParallelBufferingConsumers || (exports.ParallelBufferingConsumers = {}));